<template>
  <div
    class="auth-wrapper auth-v2"
    :dir="$functions.currentLangDirection()"
  >
    <b-row
      class="auth-inner m-0"
      style="direction: ltr;"
    >
      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-0"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5 form-auth"
        :style="{ backgroundImage: `url(${backgroundUrl})` }"
        style="background-size: cover;background-position: center;"
      >
        <!-- Brand logo-->
        <b-link class="brand-logo">

          <h2 class="brand-text text-primary ml-1" />
          <span class="brand-logo">
            <!-- <b-img
              :src="appLogoImage"
            alt="logo"
          />-->
          </span>
        </b-link>
        <!-- /Brand logo-->
        <b-col
          sm="8"
          md="6"
          lg="12"
          style="margin-top: -140px;"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('Register') }}
          </b-card-title>
          <b-card-text class="mb-2" />

          <!-- form -->
          <validation-observer
            ref="registerForm"
            #default="{invalid}"
          >
            <div
              class="auth-register-form mt-2 "
            >
              <!-- username -->
              <b-form-group
                :label="$t('Name')"
                label-for="register-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="register-name"
                    v-model="user.name"
                    name="register-name"
                    :dir="$functions.currentLangDirection()"
                    :state="errors.length > 0 ? false:null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group
                :label="$t('Family')"
                label-for="register-family"
                :dir="$functions.currentLangDirection()"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Family"
                  vid="family"
                  rules="required"
                >
                  <b-form-input
                    id="register-family"
                    v-model="user.family"
                    name="register-family"
                    :state="errors.length > 0 ? false:null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group
                label-for="register-mobile"
                :label="$t('Mobile number')"
              >
                <validation-provider
                  #default="{ errors }"
                  name="mobile"
                  vid="mobile"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="register-mobile"
                      v-model="user.mobile"
                      maxlength="11"
                      class="form-control-merge "
                      style="direction: ltr;"
                      :state="errors.length > 0 ? false:null"
                      name="register-mobile"
                      placeholder="09121234567"
                      @keyup="mobileChangeEn($event)"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                variant="success"
                block
                type="submit"
                :disabled="invalid && loading"
                @click="registerFormFunc"
              ><b-spinner
                 v-if="loading"
                 variant="outline-primary"
                 small
               />
                {{ $t('Register') }}
              </b-button>
            </div>
          </validation-observer>

          <p class="text-center mt-2">
            <span>{{ $t('Already registered') }}</span>
            <b-link :to="{name:'login'}">
              <span style="font-weight: bolder; text-decoration: underline">&nbsp;{{ $t('Sign in') }}</span>
            </b-link>
          </p>
          <div class="mt-1" style="text-align: center;">
            <b-link
              style="color: white; text-decoration: underline"
              @click="changeAppLanguage('fa')"
            >
              {{ $t('Persian') }}
            </b-link>&nbsp;
            <b-link
              style="color: white; text-decoration: underline"
              @click="changeAppLanguage('en')"
            >
              {{ $t('English') }}
            </b-link>
          </div>
        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BImg, BCardTitle, BCardText, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import Vue from 'vue'
import store from '@/store/index'
import User from '@/models/user'
import { functions } from '@/functions'

Vue.prototype.$functions = functions

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      user: new User('', '', '', '', ''),
      status: '',
      username: '',
      userEmail: '',
      password: '',
      sideImg: require('@/assets/images/pages/login-v2.jpg'),
      backgroundImg: require('@/assets/images/pages/lg.jpg'),
      // validation
      required,
      email,
      loading: false,
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      return this.sideImg
    },
    backgroundUrl() {
      return this.backgroundImg
    },
  },
  mounted() {
    const { isRTL } = $themeConfig.layout
    const formGroup = document.getElementsByClassName('form-auth')
    formGroup[0].style.direction = isRTL ? 'rtl' : 'ltr'
  },
  methods: {
    changeAppLanguage(lang) {
      localStorage.setItem('locale', lang)
      window.location = '/'
    },
    registerFormFunc() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          this.loading = true
          this.$store.dispatch('auth/register', this.user).then(
            () => {
              this.loading = false
              Vue.prototype.$mobileR = this.user.mobile
              this.$router.push('/register-verify')
            }, error => {
              this.loading = false
              this.loading = false
              this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Error'),
                  text: this.message,
                  icon: 'XIcon',
                  variant: 'danger',
                  dir: Vue.prototype.$functions.currentLangDirection(),
                },
              })
            },
          )
        }
      })
    },
    mobileChangeEn(event) {
      this.user.mobile = this.$functions.fixNumbers(event.target.value)
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
[dir=ltr], [dir=ltr] .ltr * {
  direction: ltr !important;
  text-align: left;
}

@import '../../@core/scss/vue/pages/page-auth.scss';
.brand-logo img{
  width: 70px;
}
.auth-wrapper .auth-bg{
  background-color: #232633;
  color: #fff;
}
.auth-wrapper label,.auth-wrapper span,.auth-wrapper h2,.auth-wrapper .brand-text{
  color: #fff !important;
}
</style>
